import { render, staticRenderFns } from "./videoPlayer.vue?vue&type=template&id=38df63fc"
import script from "./videoPlayer.vue?vue&type=script&lang=ts"
export * from "./videoPlayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports